import { useState } from 'react';
import { invokeEvent } from 'shared-base';
import IconButton from '../IconButton/IconButton';
import IconButtonOn from '../IconButtonOn/IconButtonOn';
import Prompt from '../Prompt/Prompt';
import { Wrapper } from './PrompterEdit.style';

export type PrompterEditProps = {
  mode: EditMode;
  onPrompt: (prompt: string, onlySlot?: boolean) => void;
  isAiRunning: boolean;
  isEmployee: boolean;
};

const ctaMap: any = {
  object: {
    text: 'Tweak Model',
    color: 'pink',
    placeholder: 'Describe the change you want to make to the model',
  },
  material: {
    text: 'Tweak Material',
    color: 'grape',
    placeholder: 'Describe the change you want to make to the material',
  },
};

export function PrompterEdit(props: PrompterEditProps) {
  const { mode, isAiRunning, isEmployee } = props;
  const [onlySlot, setOnlySlot] = useState(false);

  const ctaText = ctaMap[mode]?.text;

  function onPrompt(value: string) {
    props.onPrompt(value, onlySlot);
  }

  function onStartRealtime() {
    invokeEvent('REALTIME', { verb: 'start' });
  }

  function renderIcon() {
    if (mode === 'material') {
      return (
        <IconButtonOn
          name='IconTarget'
          tooltip='Only change selected slot'
          value={onlySlot}
          onChange={setOnlySlot}
        />
      );
    }

    if (isEmployee) {
      return (
        <IconButton name='IconMicrophone' tooltip='Realtime voice' onClick={onStartRealtime} />
      );
    }
  }

  const placeholder = ctaMap[mode]?.placeholder;
  const color = ctaMap[mode]?.color;

  return (
    <Wrapper className='PrompterEdit-wrapper' data-testid='PrompterEdit-wrapper'>
      <Prompt
        placeholder={placeholder}
        suggestions={[]}
        onPrompt={onPrompt}
        ctaText={ctaText}
        ctaColor={color}
        isLoading={isAiRunning}
      >
        {renderIcon()}
      </Prompt>
    </Wrapper>
  );
}

export default PrompterEdit;
